<div class="header">
  <h1 class="title">
    <a class="back-cont" (click)="goBack()">
      <i class="fa fa-chevron-left"></i>
    </a>
    <muni-gameday-gameday-header-title
      class="c-d-block c-text-ellipsis"
    ></muni-gameday-gameday-header-title>
  </h1>
  <muni-gameday-gameday-header-sidebar></muni-gameday-gameday-header-sidebar>
</div>
<muni-gameday-gameday></muni-gameday-gameday>
